<template lang="pug">
#Theme
  .theme-mode.default-mode(v-if="isDefault")
    .theme-btn.blue(@click="BlueMode") 藍底白字
      img.othermod(src="@/assets/img/icon/othermod.png")
    .theme-btn.dark(@click="DarkMode") 黑底黃字
      img.othermod(src="@/assets/img/icon/othermod.png")
  .theme-mode.other-mode(v-else)
    .theme-btn.default(@click="DefaultMode") 
      img.defaulmod(src="@/assets/img/icon/defaulmod.png")
    .theme-btn.blue(
      @click="BlueMode", 
      :class="{ active: modeState == 'blue' }"
    ) 藍底白字
      img.othermod(src="@/assets/img/icon/othermod.png")
    .theme-btn.dark(
      @click="DarkMode",
      :class="{ active: modeState == 'dark' }"
    ) 黑底黃字
      img.othermod(src="@/assets/img/icon/othermod.png")
</template>

<script>
export default {
  name: "Theme",
  data() {
    return {
      isDefault: true,
      modeState: "default"
    };
  },
  created() {
    this.getModeState();
  },
  methods: {
    getModeState() {
      let modeState = localStorage.getItem('Mode');
      this.modeState = modeState;
      if(modeState === 'default' || modeState === null) {
        document.documentElement.setAttribute('data-theme', 'default');
        this.isDefault = true;
      }else if(modeState === 'blue'){
        document.documentElement.setAttribute('data-theme', 'blue');
        this.isDefault = false;
      }else if(modeState === 'dark'){
        document.documentElement.setAttribute('data-theme', 'dark');
        this.isDefault = false;
      }
    },
    DefaultMode() {
      document.documentElement.setAttribute('data-theme', 'default');
      localStorage.setItem('Mode','default');
      this.isDefault = true;
    },
    BlueMode() {
      document.documentElement.setAttribute('data-theme', 'blue');
      localStorage.setItem('Mode','blue');
      this.isDefault = false;
      this.modeState = "blue";
    },
    DarkMode() {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('Mode','dark');
      this.isDefault = false;
      this.modeState = "dark";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/theme";
.font-btn-color{
  color: var(--font-btn-color) !important;
}
</style>